import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

// What a page shows in place of its loader when the data it waits for could not
// be loaded. Takes its strings ready-made: before sign-in completes, translations
// are not initialized yet.
const LoadFailed = ({ message, retryLabel, onRetry }) => (
  <div role="alert" className="text-center py-5">
    <p className="text-body mb-3">{message}</p>
    <Button color="primary" onClick={onRetry}>
      {retryLabel}
    </Button>
  </div>
);

LoadFailed.propTypes = {
  message: PropTypes.string.isRequired,
  retryLabel: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default LoadFailed;
